import React from "react";
import SpinnerOverlay from "src/components/common/SpinnerOverlay";
import PDAHeader from "src/components/common/Header";
import usePDA1091_R01Store from "./PDA1091_R01Store";
import { usePDAContainer } from "src/hooks/usePDAContainer";
import PDA1091_R01Info from "./PDA1091_R01Info";
import PDA1091_R01Table from "./PDA1091_R01Table";

interface Props {
  menuNm: string;
  menuCd?: string;
  onBack?: () => void;
}

const PDA1091_R01Container = ({ menuNm, menuCd, onBack }: Props) => {
  const { loading, reset } = usePDA1091_R01Store();
  const { handleMenuClick } = usePDAContainer(reset);

  return (
    <div className="w-full h-screen flex flex-col bg-white fixed inset-0">
      <PDAHeader menuNm={menuNm} menuCd={menuCd} onBack={onBack} onMenuClick={handleMenuClick} />

      <div className="flex-1 min-h-0 flex flex-col">
        <div className="flex-shrink-0 overflow-y-auto overflow-x-hidden">
          <PDA1091_R01Info />
        </div>
        <div className="flex-1 min-h-0 overflow-hidden">
          <PDA1091_R01Table />
        </div>
      </div>

      {loading && <SpinnerOverlay text="처리 중입니다..." />}
    </div>
  );
};

export default PDA1091_R01Container;
